import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { TitleStrategy, provideRouter, withComponentInputBinding, withPreloading } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AUTH_PROVIDERS } from '@core/authentication/auth-config';
import { ErrorHandlerService } from '@core/errors/error.handler';
import { INTERCEPTORS } from '@core/interseptors';
import { TRANSLATE_MODULE_CONFIG } from '@core/services/localization';
import { TitleService } from '@core/services/localization/title.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes, withComponentInputBinding(), withPreloading(QuicklinkStrategy)),
        provideAnimationsAsync(),
        ...AUTH_PROVIDERS,
        TRANSLATE_MODULE_CONFIG,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        ...INTERCEPTORS,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: TitleStrategy, useClass: TitleService },
    ],
};
